
export default {
  name: 'FaqListItem',
  props: {
    folded: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      //   question: this.data.question,
      //   answer: this.data.answer,
      isFolded: this.folded,
    }
  },
  watch: {
    folded(val) {
      this.isFolded = val
    },
  },
  methods: {
    toggle() {
      this.isFolded = !this.isFolded
    },
  },
}
